import React from 'react';
import { Route, Router } from '../../routing';
import ApiKeyOverview from './ApiKeyOverview';

Router.addRoute(
  new Route('API Keys', '/api-keys', <ApiKeyOverview />)
    .requireLogin()
    .role('ROLE_ADMIN'),
);
